export const GAINS_VERSION = 'V1.00.0';
